module.exports = __webpack_public_path__ + "img/verify5.4dd29f4f.png";